import {
  faBuilding,
  faCheck,
  faClipboard,
  faClock,
  faClose,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileInvoice,
  faFilePdf,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMinus,
  faMobileAlt,
  faPen,
  faPhone,
  faPlus,
  faPrint,
  faSave,
  faSearch,
  faStore,
  faTrash,
  faUser,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { apiUrl } from "../../comps/apiUrl";
import { toast } from "react-toastify";
import { StaticDialog, Confirm, Dialog } from "react-st-modal";
import {
  TextField,
  Button,
  MenuItem,
  Grid,
  IconButton,
  InputAdornment,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  Menu,
} from "@mui/material";

import InputMask from "react-input-mask";
import CadastrarCliente from "../../comps/CadastrarCliente";
import MultiSelectList from "../../comps/MultiSelectList";
import SelecionarCliente from "../../comps/SelecionarCliente";
import EquipamentoSearch from "./EquipamentoSearch";
class Lease extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      showModal: false,
      data: [],
      dados: [],
      dataClient: [],
      addEquipament: false,
      busca: "",
      rBusca: [],
      f: 2,
      BuscaM: "",
      rBuscaM: [],
      files: [],
      products: [],
      newProduct: false,
      equipaments: [],
      cpfCnpj: "",
      previews: [],
      tpcad: undefined,
      changeItens: {},
      openDropdownId: null, // Guarda o ID do dropdown aberto
      saved: undefined,
      scliente: false,
      errorProduct: {},
    };
    this.dropdownRefs = {}; // Armazena referências para os dropdowns
  }
  handleCpfCnpjChange = (e) => {
    console.log(e.target);
    function cnpj(v) {
      v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
      v = v.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
      v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
      return v;
    }

    function cpf(v) {
      v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
      v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
      return v;
    }

    if (e.target.value.length > 18) return;

    if (e.target.value.length <= 14) {
      this.setState({
        cpfCnpj: cpf(e.target.value),
      });
    } else {
      this.setState({
        cpfCnpj: cnpj(e.target.value),
      });
    }
  };
  DateNow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Mês começa em 0
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    // Formata no padrão YYYY-MM-DDTHH:mm
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  componentDidMount() {
    document.title = "Locação";
    this.setState({
      dados: {
        start_day: this.DateNow(),
        type_c: 1,

        equipamentos: [],
      },
    });
    fetch(`${apiUrl}/leaser`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status == 510) {
          window.localStorage.clear();
          window.location.href = "/";
        }
        if (response.status == 200) {
          response.json().then((data) => {
            this.setState({
              data: {
                ...data,
                type: "location",
                receiptType: undefined
              },
              loader: false,
            });
          });
        }
      })
      .catch((error) => {
        toast.error("Ocorreu um erro ao carregar as informações");
      });

    document.addEventListener("keydown", this.handleKeyPress);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    // Remove o listener ao desmontar o componente
    document.removeEventListener("keydown", this.handleKeyPress);
  }
  toggleDropdown = (id) => {
    this.setState((prevState) => ({
      openDropdownId: prevState.openDropdownId === id ? null : id, // Fecha se clicar de novo
    }));
  };

  validateSelection = () => {
    const { products } = this.state;
    let isValid = true;
    if (this.state.data.type == "venda") {
      return isValid;
    }
    products.forEach((product) => {
      // Verifica apenas se itens for igual a 1
      if (product.itens === 1) {
        const selectedCount = product.itens_selected
          ? product.itens_selected.length
          : 0;

        // Verifica se a quantidade selecionada coincide com a quantidade solicitada
        if (selectedCount !== product.quantity) {
          isValid = false;
          toast.warn(
            `Atenção: O produto "${product.name.trim()}" precisa de ${product.quantity
            } item(s) selecionado(s), mas tem ${selectedCount}.`
          );
        }
      }
    });

    if (isValid) {
      console.log("Tudo certo! Pode prosseguir.");
      // Lógica para salvar ou avançar
    }

    return isValid;
  };

  handleClickOutside = (event) => {
    // Verifica se o clique foi fora do dropdown aberto
    if (
      this.state.openDropdownId !== null &&
      this.dropdownRefs[this.state.openDropdownId] &&
      !this.dropdownRefs[this.state.openDropdownId].contains(event.target)
    ) {
      this.setState({ openDropdownId: null });
    }
  };
  handleKeyPress = (event) => {
    if (event.key === "F1") {
      if (
        this.state.addEquipament == true ||
        this.state.dados.cliente != undefined
      ) {
        return;
      }
      event.preventDefault(); // Evita o comportamento padrão do navegador

      this.setState({ showModal: true });
    }

    if (event.key === "F2") {
      if (this.state.dados.cliente == undefined) {
        return;
      }
      this.setState({
        addEquipament: true,
      });
    }

    if (event.key === "F4") {
    }
  };

  handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    let validFiles = [];
    let previews = [];

    files.forEach((file) => {
      if (file.type.startsWith("image/")) {
        validFiles.push(file);
        previews.push({ src: URL.createObjectURL(file), type: "image" });
      } else if (file.type === "application/pdf") {
        validFiles.push(file);
        previews.push({ type: "pdf" }); // Placeholder para PDFs
      } else {
        toast.error("Apenas imagens e PDFs são permitidos!");
      }
    });

    // Concatenar os novos arquivos com os existentes
    this.setState((prevState) => ({
      files: [...prevState.files, ...validFiles], // Guarda todos os arquivos
      previews: [...prevState.previews, ...previews], // Guarda pré-visualizações (imagens reais e placeholder para PDF)
    }));
  };

  handleRemoveImage = (index) => {
    const { files, previews } = this.state;

    // Remover o arquivo e a pré-visualização do estado
    const updatedFiles = files.filter((_, i) => i !== index);
    const updatedPreviews = previews.filter((_, i) => i !== index);

    this.setState({ files: updatedFiles, previews: updatedPreviews });
  };
  TypeBlock(type) {
    if (type == 0) {
      return <span>Desbloqueado</span>;
    } else if (type == 1) {
      return <span style={{ color: "red" }}>Bloqueado Para Locação</span>;
    } else if (type == 2) {
      return <span style={{ color: "red" }}>Bloqueado Para Serviço</span>;
    } else if (type == 3) {
      return <span>Bloqueio Total</span>;
    } else {
      return <span>Desbloqueado</span>;
    }
  }

  formatDate(dateString) {
    var e = dateString.split("-");
    var dateString = e[2] + "/" + e[1] + "/" + e[0];
    return dateString;
  }
  handleStartDateChange = (event) => {
    this.setState({ startDate: event.target.value }, this.calculateDifference);
  };

  handleEndDateChange = (event) => {
    this.setState({ endDate: event.target.value }, this.calculateDifference);
  };

  calculateDifference = () => {
    const { startDate, endDate } = this.state;

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (
        start instanceof Date &&
        end instanceof Date &&
        !isNaN(start) &&
        !isNaN(end)
      ) {
        const differenceInTime = end.getTime() - start.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        this.setState({
          dayDifference: Math.max(0, Math.floor(differenceInDays)),
        });
      } else {
        this.setState({ dayDifference: null });
      }
    } else {
      this.setState({ dayDifference: null });
    }
  };
  formatarMoeda = (valor) => {
    // Remove caracteres que não sejam números
    const apenasNumeros = valor.replace(/\D/g, "");
    // Converte para número e formata em BRL
    const valorFormatado = (Number(apenasNumeros) / 100).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL",
      }
    );
    return valorFormatado;
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados, // Mantém os outros campos do objeto `dados`
        [name]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };

  handlenCChange = (event) => {
    const { name, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      dataClient: {
        ...prevState.dataClient, // Mantém os outros campos do objeto `dados`
        [name]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };

  EndDay() {
    var billing = {
      1: 1,
      2: 7,
      3: 15,
      4: 30,
      5: 365,
    };

    const date = new Date(this.state.dados.start_day);
    if (!isNaN(date)) {
      var dias =
        this.state.dados.period !== undefined
          ? this.state.dados.period * billing[this.state.dados.faturamento]
          : 0;
      date.setDate(date.getDate() + dias);

      // Construção manual do formato 'YYYY-MM-DD HH:mm'
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    } else {
      return 0;
    }
  }
  calculateTotal = () => {
    var billing = {
      1: 1,
      2: 7,
      3: 15,
      4: 30,
      5: 365,
    };
    if (this.state.data.type == "venda" || this.state.data.type == "o-v") {
      return this.state.products.reduce((total, item) => {
        const selectedPrice = item.value; // Preço selecionado com base no faturamento
        return total + selectedPrice * item.quantity; // Soma o preço de cada item com a quantidade
      }, 0); // Multiplica o total final pelos dias
    } else {
      return (
        this.state.products.reduce((total, item) => {
          const selectedPrice = item.price[this.state.dados.faturamento]; // Preço selecionado com base no faturamento
          return total + selectedPrice * item.quantity; // Soma o preço de cada item com a quantidade
        }, 0) * this.state.dados.period
      ); // Multiplica o total final pelos dias
    }
  };

  highlightMatch = (text, search) => {
    if (!search) return text;

    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // escapa regex
    const regex = new RegExp(`(${escapedSearch})`, "gi");

    return text
      .split(regex)
      .map((part, i) =>
        regex.test(part) ? <strong key={i}>{part}</strong> : part
      );
  };

  getMaskForFilter = () => {
    switch (this.state.f) {
      case "4": // CNPJ
        return "99.999.999/9999-99";
      case "5": // CPF
        return "999.999.999-99";
      case "6": // Telefone fixo
        return "(99) 9999-9999";
      case "7": // WhatsApp (assumindo celular com 9 dígitos)
        return "(99) 99999-9999";
      default:
        return ""; // Sem máscara
    }
  };
  // Dentro da sua class component
  updateQuantity = (id, newQuantity, maxStock) => {
    // Garante que não ultrapasse o estoque e não seja menor que 1
    let validatedQuantity = Math.max(1, Math.min(newQuantity, maxStock));

    this.setState((prevState) => ({
      products: prevState.products.map((item) =>
        item.id === id ? { ...item, quantity: validatedQuantity } : item
      ),
    }));
  };
  render() {
    if (this.state.loader) {
      return (
        <div className="area-loader">
          <div className="loader"></div>
        </div>
      );
    }
    var { dayDifference } = this.state;

    const total = this.calculateTotal(); // Total calculado
    var EndDay = this.EndDay();
    return (
      <div className="content">
        <SelecionarCliente
          open={this.state.scliente}
          operation={this.state.data.type}
          onClose={() => this.setState({ scliente: false })}
          onSelect={(item) => {
            console.log(item);
            this.setState((prevState) => ({
              dados: {
                ...prevState.dados, // Mantém os dados existentes
                cliente: {
                  id: item.id,
                  nome: item.nome,
                  cnpj_cpf: item.cnpj_cpf,
                  logradouro: item.endereco,
                  numero: item.numero,
                  cMun: "",
                  bairro: item.bairro,
                  xMun: item.cidade,
                  uf: item.uf,
                  cep: item.cep

                }, // Adiciona a nova propriedade cliente
              },
            }));
            this.setState({ scliente: false });
          }}
        />
        <div className="card bg-light">
          <div className="card-header d-flex align-items-center justify-content-between">
            <strong>Locação de Equipamentos</strong>
            <Link className="btn btn-success" to="/lease-history">
              <FontAwesomeIcon icon={faClock} /> Histórico de Locações
            </Link>
          </div>
          <div className="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <TextField
                  select
                  label="Tipo"
                  fullWidth // O campo ocupa toda a largura disponível
                  margin="normal"
                  InputProps={{
                    style: {
                      height: 45,
                      padding: "0 5px",
                    },
                  }}
                  value={this.state.data.type}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      return;
                    }
                    this.setState({
                      data: {
                        ...this.state.data, // Mantém os outros campos do objeto `data`
                        ["type"]: e.target.value, // Atualiza apenas o campo correspondente
                      },
                    });
                  }}
                >
                  <MenuItem value="location">Locação</MenuItem>
                  {/*<MenuItem value="sale">Venda</MenuItem>*/}
                  <MenuItem value="o-l">Orçamento</MenuItem>
                  <MenuItem value="venda">Venda</MenuItem>
                  {/*<MenuItem value="o-v">Orçamento Venda</MenuItem>*/}
                </TextField>
              </div>
              <div class="col-md-4">
                <TextField
                  label="Vendedor"
                  fullWidth // O campo ocupa toda a largura disponível
                  margin="normal"
                  InputProps={{
                    style: {
                      height: 45,
                      padding: "0 5px",
                    },
                  }}
                  type="text"
                  value={this.state.data.sellers.name}
                  disabled
                />
              </div>
              <div class="col-md-4">
                <TextField
                  label="Loja"
                  fullWidth // O campo ocupa toda a largura disponível
                  margin="normal"
                  InputProps={{
                    style: {
                      height: 45,
                      padding: "0 5px",
                    },
                  }}
                  value={this.state.data.store.name}
                  disabled
                />
              </div>
            </div>

            <div className="card mb-3">
              <div className="card-header d-flex align-items-center justify-content-between">
                <strong>Informações do Cliente</strong>{" "}
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      this.setState({ scliente: true });
                    }}
                    disabled={this.state.dados.cliente != undefined}
                    startIcon={<FontAwesomeIcon icon={faUser} />}
                  >
                    Selecionar Cliente
                  </Button>
                  <CadastrarCliente
                    dados={this.state.dados}
                    response={(data) => {
                      this.setState((prevState) => ({
                        dados: {
                          ...prevState.dados, // Mantém os dados existentes
                          cliente: {
                            id: data.id,
                            nome: data.nome,
                            cnpj_cpf: data.cnpj_cpf,
                          }, // Adiciona a nova propriedade cliente
                        },
                      }));
                    }}
                    asClient={this.state.dados.cliente != undefined}
                  />
                </div>
              </div>
              <div className="card-body">
                {this.state.dados.cliente != undefined ? (
                  <>
                    <table class="table table-striped table-bordered arvore-l mt-2">
                      <thead class="table-dark text-center align-middle">
                        <tr>
                          <th>Nome</th>
                          <th>Documento</th>
                          <th>Opção</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{this.state.dados.cliente.nome}</td>
                          <td>{this.state.dados.cliente.cnpj_cpf}</td>
                          <td>
                            <button
                              class="btn btn-danger"
                              onClick={(e) => {
                                this.setState((prevState) => {
                                  const { cliente, ...rest } = prevState.dados; // Desestrutura e exclui "cliente"
                                  return {
                                    dados: rest, // Atualiza "dados" com o restante das propriedades
                                  };
                                });
                              }}
                            >
                              Excluir
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>Nenhum cliente selecionado</>
                )}
              </div>
            </div>

            <div className="card mt-3">
              <div className="card-header d-flex justify-content-between">
                <strong>Equipamentos</strong>
              </div>
              <div className="card-body">
                {this.state.products.length > 0 &&
                  this.state.products.map((product, index) => {
                    // Validação dos dados fiscais do produto para Venda
                    const isVenda = this.state.data.type === "venda";
                    const hasMissingFiscalData =
                      isVenda &&
                      (!product.ncm ||
                        !product.cfop ||
                        !product.uCom ||
                        !product.gtin);

                    return (
                      <div key={product.id || index} className="card mb-3">
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <strong>{product.name}</strong>
                          <div></div>
                        </div>
                        <div className="card-body">
                          {/* Exibe o alerta caso falte alguma informação fiscal no modo Venda */}
                          {hasMissingFiscalData && (
                            <Alert severity="warning" className="mb-3">
                              <strong>Atenção:</strong> Este produto possui dados fiscais
                              incompletos para venda (NCM, CFOP, uCom ou GTIN ausentes). Preencha
                              o cadastro para emitir a nota fiscal.
                            </Alert>
                          )}

                          <div className="row">
                            <div className="col-md-3">
                              <fieldset className="fd-qtd">
                                <legend>Código de barra</legend>
                                <div>{product.codigo_barra || product.gtin}</div>
                              </fieldset>
                            </div>
                            <div className="col-md-2">
                              <fieldset className="fd-qtd">
                                <legend>Estoque</legend>
                                <div>
                                  {this.state.data.store.id == 1
                                    ? product.stockone
                                    : product.stocktwo}
                                </div>
                              </fieldset>
                            </div>

                            <div className="col-md-2">
                              {this.state.data.type == "location" ||
                                this.state.data.type == "o-l" ? (
                                <fieldset className="fd-qtd">
                                  <legend>Valor Unitário</legend>
                                  <div>
                                    {this.state.dados.faturamento != undefined
                                      ? product.price[
                                        this.state.dados.faturamento
                                      ].toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })
                                      : "----"}
                                  </div>
                                </fieldset>
                              ) : (
                                <fieldset className="fd-qtd">
                                  <legend>Valor Unitário</legend>
                                  <div>
                                    {product.value.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </div>
                                </fieldset>
                              )}
                            </div>

                            <div className="col-md-3 aaj">
                              <TextField
                                label="Quantidade"
                                type="text"
                                variant="outlined"
                                fullWidth
                                value={product.quantity === 0 ? "" : product.quantity}
                                onChange={(e) => {
                                  const val = parseInt(e.target.value, 10);
                                  const max =
                                    this.state.data.store.id === 1
                                      ? product.stockone
                                      : product.stocktwo;

                                  if (!isNaN(val)) {
                                    this.updateQuantity(product.id, val, max);
                                  } else {
                                    this.updateQuantity(product.id, 0, max);
                                  }
                                }}
                                onBlur={() => {
                                  if (product.quantity < 1) {
                                    const max =
                                      this.state.data.store.id === 1
                                        ? product.stockone
                                        : product.stocktwo;
                                    this.updateQuantity(product.id, 1, max);
                                  }
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          const max =
                                            this.state.data.store.id === 1
                                              ? product.stockone
                                              : product.stocktwo;
                                          this.updateQuantity(
                                            product.id,
                                            product.quantity - 1,
                                            max
                                          );
                                        }}
                                        disabled={product.quantity <= 1}
                                      >
                                        <FontAwesomeIcon icon={faMinus} size="xs" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          const max =
                                            this.state.data.store.id === 1
                                              ? product.stockone
                                              : product.stocktwo;
                                          if (product.quantity >= max) {
                                            toast.warn("Estoque máximo atingido");
                                          } else {
                                            this.updateQuantity(
                                              product.id,
                                              product.quantity + 1,
                                              max
                                            );
                                          }
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPlus} size="xs" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                inputProps={{
                                  style: {
                                    textAlign: "center",
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                  min: 1,
                                }}
                              />
                            </div>

                            <div className="col-md-2">
                              <fieldset className="fd-qtd">
                                <legend>Valor Total</legend>
                                <div>
                                  {this.state.data.type === "venda"
                                    ? (product.quantity * product.value).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                    : this.state.dados.faturamento != undefined
                                      ? (
                                        product.quantity *
                                        product.price[this.state.dados.faturamento]
                                      ).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })
                                      : (product.quantity * product.value).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                      })}
                                </div>
                              </fieldset>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <TextField
                                label="Caracteristicas do Equipamento"
                                onChange={(e) => {
                                  var id = product.id;
                                  this.setState((prevState) => {
                                    const novosItens = prevState.products.map((item) => {
                                      if (item.id === id) {
                                        return {
                                          ...item,
                                          cdp: e.target.value,
                                        };
                                      }
                                      return item;
                                    });

                                    return { products: novosItens };
                                  });
                                }}
                                value={product.cdp}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                              />
                            </div>
                          </div>

                          {product.itens == 1 && this.state.data.type == "location" && (
                            <MultiSelectList
                              id={product.id}
                              quantity={product.quantity}
                              onSelect={(itens) => {
                                var id = product.id;
                                this.setState((prevState) => {
                                  const novosItens = prevState.products.map((item) => {
                                    if (item.id === id) {
                                      return {
                                        ...item,
                                        itens_selected: itens,
                                      };
                                    }
                                    return item;
                                  });
                                  return { products: novosItens };
                                });
                              }}
                              onRemove={(itemRemovido) => {
                                const id = product.id;

                                this.setState((prevState) => {
                                  const novosProdutos = prevState.products.map((prod) => {
                                    if (prod.id === id) {
                                      return {
                                        ...prod,
                                        itens_selected: prod.itens_selected.filter(
                                          (it) => it.id !== itemRemovido.id
                                        ),
                                      };
                                    }
                                    return prod;
                                  });

                                  return { products: novosProdutos };
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}

                {/* Trava também o botão caso algum produto esteja com dados incompletos */}
                <div className="d-flex justify-content-center">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      this.setState({
                        addEquipament: true,
                      });
                    }}
                    disabled={
                      this.state.data.type == undefined ||
                      this.state.dados.cliente == undefined ||
                      (this.state.data.type === "venda" &&
                        this.state.products.some(
                          (p) => !p.ncm || !p.cfop || !p.uCom || !p.gtin
                        ))
                    }
                  >
                    Selecionar Equipamentos
                  </Button>
                  <EquipamentoSearch
                    open={this.state.addEquipament}
                    selectedProducts={this.state.products}
                    onSave={(data) => {
                      this.setState({
                        products: data,
                        addEquipament: false,
                      });
                    }}
                    onClose={() => {
                      this.setState({ addEquipament: false });
                    }}
                  />
                </div>
              </div>
            </div>



            {(
              this.state.data.type == "venda") && (
                <div className="card mt-3 mb-5">
                  <div className="card-header">
                    <strong>Detalhes</strong>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">  <TextField
                        label="Observação"
                        fullWidth // O campo ocupa toda a largura disponível
                        margin="normal"
                        InputProps={{
                          style: {
                            height: 45,
                            padding: "0 5px",
                          },
                        }}
                        value={this.state.dados.obs}
                        onChange={(e) => {
                          this.setState((prevState) => ({
                            dados: {
                              ...prevState.dados, // Mantém os outros campos do objeto `dados`
                              ["obs"]: e.target.value, // Atualiza apenas o campo correspondente
                            },
                          }));
                        }}
                        placeholder="Digite:"
                      /></div>
                      <div className={
                        this.state.dados.tpay == "boletop" ? "col-md-3" : "col-md-6"
                      }>
                        <TextField
                          select
                          label="Forma de Pagamento"
                          fullWidth // O campo ocupa toda a largura disponível
                          margin="normal"
                          value={this.state.dados.tpay}
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                          name="tpay"
                          onChange={(e) => this.handleChange(e)}
                          required=""
                        >
                          <MenuItem value="pne">
                            Pagamento Na Entrega
                          </MenuItem>
                          <MenuItem value="pnd">
                            Pagamento Na Devolução
                          </MenuItem>
                          <MenuItem value="boletop">Boleto</MenuItem>
                          <MenuItem value="cartaoc">
                            Cartão de Crédito
                          </MenuItem>
                          <MenuItem value="cartaod">
                            Cartão de Débito
                          </MenuItem>
                          <MenuItem value="dinheiro">Dinheiro</MenuItem>
                          <MenuItem value="pix">PIX</MenuItem>
                        </TextField>
                      </div>
                      {this.state.dados.tpay == "boletop" && (
                        <div class="col-md-3">
                          <TextField
                            select
                            label="Selecione as parcelas"
                            name="parcelas"
                            onChange={(e) => this.handleChange(e)}
                            fullWidth
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          >
                            <MenuItem value="1">1 Parcela</MenuItem>
                            <MenuItem value="2">2 Parcelas</MenuItem>
                            <MenuItem value="3">3 Parcelas</MenuItem>
                            <MenuItem value="4">4 Parcelas</MenuItem>
                            <MenuItem value="5">5 Parcelas</MenuItem>
                            <MenuItem value="6">6 Parcelas</MenuItem>
                            <MenuItem value="7">7 Parcelas</MenuItem>
                            <MenuItem value="8">8 Parcelas</MenuItem>
                            <MenuItem value="9">9 Parcelas</MenuItem>
                            <MenuItem value="10">10 Parcelas</MenuItem>
                            <MenuItem value="11">11 Parcelas</MenuItem>
                            <MenuItem value="12">12 Parcelas</MenuItem>
                          </TextField>
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              )}






            {(this.state.data.type == "o-l" ||
              this.state.data.type == "location") && (
                <div className="card mt-3 mb-5">
                  <div className="card-header">
                    <strong>Detalhes</strong>
                  </div>
                  <div className="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <TextField
                          select
                          label="Faturamento"
                          id="faturamento"
                          name="faturamento"
                          fullWidth
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                          onChange={(e) => {
                            if (e.target.value == "0") {
                              e.preventDefault();
                              return false;
                            }

                            this.handleChange(e);
                          }}
                          value={this.state.dados.faturamento}
                          disabled={
                            this.state.dados.cliente == undefined ? true : false
                          }
                        >
                          <MenuItem value="1">Diária</MenuItem>
                          <MenuItem value="2">Semanal</MenuItem>
                          <MenuItem value="3">Quinzenal</MenuItem>
                          <MenuItem value="4">Mensal</MenuItem>
                          <MenuItem value="5">Anual</MenuItem>
                        </TextField>
                      </div>
                      <div class="col-md-3">
                        <TextField
                          label="Quantidade de período"
                          value={this.state.dados.period}
                          fullWidth
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                          onChange={(e) => {
                            var value = e.target.value.replace(/\D/g, "");

                            this.setState((prevState) => ({
                              dados: {
                                ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                ["period"]: value, // Atualiza apenas o campo correspondente
                              },
                            }));
                          }}
                          disabled={
                            this.state.dados.cliente == undefined ? true : false
                          }
                        />
                      </div>
                      <div class="col-md-3">
                        <TextField
                          label="Data inicial"
                          type="datetime-local"
                          id="data-inicial"
                          fullWidth
                          inputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                          required=""
                          onChange={(e) => {
                            this.setState((prevState) => ({
                              dados: {
                                ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                ["start_day"]: e.target.value, // Atualiza apenas o campo correspondente
                              },
                            }));
                          }}
                          value={this.state.dados.start_day}
                        />
                      </div>
                      <div class="col-md-3">
                        <TextField
                          label="Data Final"
                          fullWidth
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                          type="datetime-local"
                          id="data-final"
                          value={EndDay}
                          required=""
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div class="row  d-flex align-items-center">
                      {(this.state.data.type == "o-l" ||
                        this.state.data.type == "location") && (
                          <>
                            <div class="col-md-3">
                              <TextField
                                label="Multa Por Atraso"
                                fullWidth // O campo ocupa toda a largura disponível
                                margin="normal"
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                value={this.state.dados.multa}
                                onChange={(e) => {
                                  this.setState((prevState) => ({
                                    dados: {
                                      ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                      ["multa"]: this.formatarMoeda(e.target.value), // Atualiza apenas o campo correspondente
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </>
                        )}

                      {(this.state.data.type == "venda" ||
                        this.state.data.type == "o-v") && (
                          <>
                            <div class="col-md-2">
                              <label for="dias-locacao" class="form-label">
                                Valor total
                              </label>
                              <input
                                value={
                                  isNaN(total)
                                    ? "R$ 0,00"
                                    : total.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                }
                                id="dias-locacao"
                                class="form-control"
                                disabled
                              />
                            </div>
                          </>
                        )}





                      {this.state.data.type != undefined && (
                        <>
                          <div class="col-md-2">
                            <TextField
                              label="Frete"
                              fullWidth // O campo ocupa toda a largura disponível
                              margin="normal"
                              InputProps={{
                                style: {
                                  height: 45,
                                  padding: "0 5px",
                                },
                              }}
                              value={this.state.dados.frete}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  dados: {
                                    ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                    ["frete"]: this.formatarMoeda(e.target.value), // Atualiza apenas o campo correspondente
                                  },
                                }));
                              }}
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              label="Observação"
                              fullWidth // O campo ocupa toda a largura disponível
                              margin="normal"
                              InputProps={{
                                style: {
                                  height: 45,
                                  padding: "0 5px",
                                },
                              }}
                              value={this.state.dados.obs}
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  dados: {
                                    ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                    ["obs"]: e.target.value, // Atualiza apenas o campo correspondente
                                  },
                                }));
                              }}
                              placeholder="Digite:"
                            />
                          </div>
                          <div class="col-md-3">
                            <TextField
                              select
                              label="Forma de Pagamento"
                              fullWidth // O campo ocupa toda a largura disponível
                              margin="normal"
                              value={this.state.dados.tpay}
                              InputProps={{
                                style: {
                                  height: 45,
                                  padding: "0 5px",
                                },
                              }}
                              name="tpay"
                              onChange={(e) => this.handleChange(e)}
                              required=""
                            >
                              <MenuItem value="pne">
                                Pagamento Na Entrega
                              </MenuItem>
                              <MenuItem value="pnd">
                                Pagamento Na Devolução
                              </MenuItem>
                              <MenuItem value="boletop">Boleto</MenuItem>
                              <MenuItem value="cartaoc">
                                Cartão de Crédito
                              </MenuItem>
                              <MenuItem value="cartaod">
                                Cartão de Débito
                              </MenuItem>
                              <MenuItem value="dinheiro">Dinheiro</MenuItem>
                              <MenuItem value="pix">PIX</MenuItem>
                            </TextField>
                          </div>
                        </>
                      )}
                    </div>
                    {dayDifference != null && (
                      <>
                        <div class="row mb-3">
                          <div class="col-md-3">
                            <label for="dias-locacao" class="form-label">
                              Dias de Locação
                            </label>
                            <input
                              value={dayDifference != null ? dayDifference : ""}
                              id="dias-locacao"
                              class="form-control"
                              disabled="true"
                            />
                          </div>

                          <div class="col-md-3">
                            <label for="valor-total" class="form-label">
                              Valor Total
                            </label>
                            <input
                              type="text"
                              id="valor-total"
                              value={(
                                dayDifference *
                                this.state.dados.quantidade *
                                this.state.dados.price
                              ).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                              class="form-control"
                              disabled="true"
                            />
                          </div>

                          <div class="col-md-3">
                            <label for="forma-pagamento" class="form-label">
                              Forma de Pagamento
                            </label>
                            <select
                              id="tpay"
                              class="form-control"
                              onChange={(e) => this.handleChange(e)}
                              required=""
                            >
                              <option value="" disabled="" selected="">
                                Selecione
                              </option>
                              <option value="pne">Pagamento Na Entrega</option>
                              <option value="pnd">Pagamento Na Devolução</option>
                              <option value="cartao">Cartão de Crédito</option>
                              <option value="cartao">Cartão de Débito</option>
                              <option value="dinheiro">Dinheiro</option>
                              <option value="pix">PIX</option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
        <div className="area-baixo">
          <div style={{ marginLeft: "15px", fontSize: "25px" }}>
            Total:{" "}
            <strong>
              {isNaN(total)
                ? "R$ 0,00"
                : total.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
            </strong>
          </div>
          <div>
            {" "}
            <div style={{ justifyContent: "flex-end" }}>


              <div style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "5px",
                marginRight: "15px"
              }}>
                {this.state.saved != undefined && (
                  <>
                    <Link
                      to={"/lease/contract/" + this.state.saved}
                      target="_blank"
                      className="btn"
                      style={{
                        marginRight: "10px",
                        background: "#8A2BE2",
                        color: "#fff",
                      }}
                      onClick={() => { }}
                    >
                      <FontAwesomeIcon color="#fff" icon={faPrint} /> Imprimir Contrato
                    </Link>
                  </>
                )}
                {(this.state.data.type == "venda" && this.state.saved == undefined) && (
                  <TextField
                    select
                    label="Tipo de Recibo"
                    value={this.state.data.receiptType}
                    onChange={(event) => {
                      this.setState((prevState) => ({
                        data: {
                          ...prevState.data,
                          receiptType: event.target.value
                        }
                      }));
                    }}
                    sx={{ width: 150 }}
                    size="small"
                  >
                    <MenuItem value="1">Não Fiscal</MenuItem>
                    <MenuItem value="2">Fiscal</MenuItem>
                  </TextField>
                )}

                {this.state.saved == undefined ? (
                  <>
                    {" "}
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={this.state.saved == undefined ? false : true}
                      onClick={async (e) => {
                        var dados = this.state.dados;
                        var products = this.state.products;
                        if (this.state.dados.cliente == undefined) {
                          toast.warn("Selecione um cliente");
                          return;
                        }
                        if (this.state.products.length == 0) {
                          toast.warn("Selecione pelo menos um produto");
                          return;
                        }

                        if (this.validateSelection() == false) {
                          return;
                        }

                        if (this.state.data.type == undefined) {
                          toast.warn("Selecione um tipo de operação");
                          return;
                        }

                        if (this.state.dados.tpay == undefined) {
                          toast.warn("Selecione uma forma de pagamento");
                          return;
                        }
                        if (this.state.data.type != "venda") {





                          if (this.state.dados.faturamento == undefined) {
                            toast.warn("Selecione um faturamento");
                            return;
                          }
                          if (this.state.dados.period == undefined) {
                            toast.warn("Selecione um periodo");
                            return;
                          }
                        } else {


                          const hasInvalidProduct = products.some((product) => {
                            return (
                              !product.ncm?.toString().trim() ||
                              !product.cfop?.toString().trim() ||
                              !product.uCom?.toString().trim() ||
                              !product.gtin?.toString().trim()
                            );
                          });

                          if (hasInvalidProduct) {
                            toast.warn("Existem produtos com cadastro fiscal incompleto (NCM, CFOP, Unidade ou GTIN/EAN).");
                            return;
                          }


                          if (this.state.data.receiptType == undefined) {
                            toast.warn("Selecione o tipo de recibo");
                            return;
                          }
                        }



                        console.log(this.state.products);
                        var send = {
                          type: this.state.data.type,
                          client: this.state.dados.cliente,
                          products: this.state.products,
                          seller: this.state.data.sellers.name,
                          receiptType: this.state.data.receiptType || null,
                          location: {
                            billing: dados.faturamento,
                            period: dados.period,
                            start_day: dados.start_day,
                            end_day: EndDay,
                            location_value: total,
                            fine: this.state.dados.multa,
                            frete: this.state.dados.frete,
                            obs: this.state.dados.obs,
                            tpay: this.state.dados.tpay,
                            parcelas: this.state.dados.parcelas || null,
                          },
                        };

                        fetch(`${apiUrl}/v2/location/new`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            authorization: localStorage.getItem("token"),
                          },
                          body: JSON.stringify(send),
                        })
                          .then((res) => {
                            if (res.status == 401) {
                              res.json().then((data) => {
                                toast.warning(data.error);
                              });
                            }
                            if (res.status == 200) {
                              res.json().then((data) => {
                                toast.success("Locação Criada com sucesso");
                                this.setState({ saved: data.token });
                                /*
                            if (this.state.data.type == "location") {
                              this.props.navigate(`/`);
                            } else if (this.state.data.type == "sale") {
                              this.props.navigate(`/sales-history`);
                            } else if (this.state.data.type == "o-l") {
                              this.props.navigate(`/budget`);
                            } else if (this.state.data.type == "o-v") {
                              this.props.navigate(`/budget/sales`);
                            }
                              */
                              });
                            }
                          })
                          .catch((error) => {
                            toast.error("Ocorreu um erro ao adicionar a locação");
                            console.error(error);
                          });
                      }}
                      startIcon={<FontAwesomeIcon icon={faSave} />}
                    >
                      Finalizar
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      color="primary"
                      variant="contained"
                      startIcon={<FontAwesomeIcon icon={faPlus} />}


                      onClick={(e) => {
                        window.location.reload();
                      }}
                    >
                      Nova Locação
                    </Button>
                  </>
                )}

              </div>



            </div>
          </div>
        </div>

        <StaticDialog
          isOpen={Object.keys(this.state.errorProduct).length > 0}
          title="Atenção!"
          onAfterClose={(result) => {
            this.setState({ errorProduct: {} });
          }}
        >
          <div className="content">
            <p>{this.state.errorProduct.message}</p>
          </div>
          <div
            style={{ display: "flex", justifyContent: "flex-end", margin: 20 }}
          >
            <button
              className="btn btn-danger"
              onClick={() => {
                this.setState({ errorProduct: {} });
              }}
            >
              Ok
            </button>
          </div>
        </StaticDialog>

        <StaticDialog
          isOpen={false}
          title="Selecionar Itens"
          onAfterClose={(result) => {
            this.setState({ changeItens: {} });
          }}
        >
          <div className="content">
            <table class="table table-striped table-bordered arvore-l">
              <thead class="table-dark text-center align-middle">
                <tr>
                  <th>CÓDIGO DO PRODUTO</th>
                  <th>OPÇÃO</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.state.changeItens).length > 0 &&
                  this.state.changeItens.itens
                    // 🛑 Adicione o método FILTER aqui para exibir apenas itens válidos
                    .filter((item) => item.available > 0)
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          {/* É uma boa prática usar uma 'key' única, como item.id_item, se disponível */}
                          <td>
                            {item.cat}.{item.sub}.{item.idu}
                          </td>
                          <td>
                            {item.selected ? (
                              <>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    this.setState({
                                      changeItens: {
                                        ...this.state.changeItens,
                                        itens: this.state.changeItens.itens.map(
                                          (it) => {
                                            if (it.id_item === item.id_item) {
                                              it.selected = false;
                                            }
                                            return it;
                                          }
                                        ),
                                      },
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} /> Remover
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-primary"
                                  // O 'disabled' foi removido aqui, pois o filtro já garante que available > 0
                                  onClick={() => {
                                    const count =
                                      this.state.changeItens.itens.filter(
                                        (item) => item.selected
                                      ).length;
                                    if (
                                      this.state.changeItens.quantity <= count
                                    ) {
                                      toast.warn("Limite de itens atingido");
                                      return;
                                    }
                                    this.setState({
                                      changeItens: {
                                        ...this.state.changeItens,
                                        itens: this.state.changeItens.itens.map(
                                          (it) => {
                                            console.log(it);
                                            if (it.id_item === item.id_item) {
                                              it.selected = true;
                                            }
                                            return it;
                                          }
                                        ),
                                      },
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faCheck} /> Selecionar
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary"
              onClick={() => {
                this.setState({ changeItens: {} });
              }}
            >
              Salvar
            </button>
          </div>
        </StaticDialog>
        <StaticDialog
          isOpen={this.state.addEquipament_old}
          title="Buscar equipamento"
          onAfterClose={(result) => {
            this.setState({ addEquipament: false, BuscaM: "", rBuscaM: [] });
          }}
        >
          <div className="content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (this.state.BuscaM.trim() == "") {
                  toast.warn("Digite algo para buscar");
                  e.target.classList.remove("load");
                  return;
                }

                fetch(`${apiUrl}/get-equipaments`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                  },
                  body: JSON.stringify({
                    name: this.state.BuscaM,
                    loca:
                      this.state.data.type == "location" ||
                        this.state.data.type == "o-l"
                        ? true
                        : false,
                  }),
                })
                  .then((res) => {
                    e.target.classList.remove("load");
                    if (res.status === 404) {
                      this.setState({ rBuscaM: null });

                      return null;
                    }
                    if (!res.ok) {
                      throw new Error("Erro ao buscar os dados");
                    }
                    return res.json();
                  })
                  .then((data) => {
                    if (data) {
                      this.setState({ rBuscaM: data });
                    }
                  })
                  .catch((error) => {
                    e.target.classList.remove("load");
                    toast.error("Ocorreu um erro ao buscar o cliente");
                    console.error(error);
                  });
              }}
            >
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Digite..."
                  onChange={(e) => this.setState({ BuscaM: e.target.value })}
                  value={this.state.BuscaM || ""}
                  className="form-control"
                />
                <button type="submit" className="btn btn-primary">
                  Buscar
                </button>
              </div>
            </form>

            <div className="mt-3">
              {this.state.rBuscaM ? (
                this.state.rBuscaM.length > 0 && (
                  <>
                    <table className="table table-striped table-bordered arvore-l">
                      <thead className="table-dark text-center align-middle">
                        <tr>
                          <th scope="col">Código de barra</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Estoque</th>
                          <th scope="col">Opção</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.rBuscaM.map((item, index) => (
                          <tr key={index}>
                            <td>{item.codigo_barra}</td>
                            <td>{item.name}</td>
                            <td> {item.estoque_disponivel}</td>

                            <td>
                              <button
                                className="btn btn-primary"
                                disabled={item.estoque_disponivel <= 0}
                                onClick={() => {
                                  const itemExists = this.state.products.some(
                                    (product) => product.id === item.id
                                  );

                                  if (itemExists) {
                                    toast.warn(
                                      "O equipamento já foi adicionado"
                                    );
                                  } else {
                                    if (
                                      item.stockone <= 1 &&
                                      item.stocktwo <= 1
                                    ) {
                                      toast.warn(
                                        "O equipamento não possui estoque suficiente"
                                      );
                                      return;
                                    }

                                    this.setState({
                                      products: [
                                        ...this.state.products,
                                        {
                                          id: item.id,
                                          codigo_barra: item.codigo_barra,
                                          name: item.name,
                                          stockone: item.stockone,
                                          stocktwo: item.stocktwo,
                                          quantity: 1,
                                          value: item.value,
                                          itens_selected: [],
                                          itens: item.itens,
                                          price: {
                                            1: item.day_price,
                                            2: item.weekly_price,
                                            3: item.biweekly_price,
                                            4: item.monthly_price,
                                            5: item.annual_price,
                                          },
                                        },
                                      ],
                                      addEquipament: false,
                                      equipaments: [],
                                      rBuscaM: [],
                                      BuscaM: "",
                                    });
                                  }
                                }}
                              >
                                Selecionar
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )
              ) : (
                <div className="text-center">Nem um resultado encontrado</div>
              )}
            </div>
          </div>
        </StaticDialog>

        <StaticDialog
          isOpen={this.state.showModal}
          title="Selecione um cliente"
          onAfterClose={(result) => {
            this.setState({ showModal: false, rBusca: [], busca: "" });
          }}
        >
          <div>
            {this.state.rBusca ? (
              this.state.rBusca.length > 0 && (
                <>
                  <div className="p-2">
                    Resultados para: <strong>{this.state.busca}</strong>
                  </div>
                  <table class="table table-striped table-bordered arvore-l">
                    <thead class="table-dark text-center align-middle">
                      <tr>
                        <th scope="col">Nome</th>
                        <th scope="col">Documento</th>
                        <th>Status</th>
                        <th scope="col">Opção</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rBusca.length > 0 &&
                        this.state.rBusca.map((item, index) => (
                          <>
                            <tr>
                              <td>
                                {this.highlightMatch(
                                  item.nome,
                                  this.state.busca
                                )}
                              </td>
                              <td>{item.cnpj_cpf}</td>
                              <td>{this.TypeBlock(item.status)}</td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  disabled={
                                    item.status == 1 || item.status == 3
                                      ? true
                                      : false
                                  }
                                  onClick={(e) => {
                                    const type = this.state.data.type;
                                    const { tipo_cliente } = item;

                                    if (tipo_cliente == null) {
                                    } else {
                                      if (type === "location") {
                                        if (tipo_cliente == 1) {
                                          // Ação se for "location" e tipo_cliente for 1
                                        } else {
                                          toast.error(
                                            "Por favor, selecione um cliente de locação."
                                          );
                                          return false;
                                        }
                                      } else if (type === "sale") {
                                        if (tipo_cliente == 2) {
                                          // Ação se for "sale" e tipo_cliente for 2
                                        } else {
                                          toast.error(
                                            "Por favor, selecione um cliente de venda."
                                          );
                                          return false;
                                        }
                                      }
                                    }

                                    this.setState((prevState) => ({
                                      dados: {
                                        ...prevState.dados, // Mantém os dados existentes
                                        cliente: {
                                          id: item.id,
                                          nome: item.nome,
                                          cnpj_cpf: item.cnpj_cpf,
                                        }, // Adiciona a nova propriedade cliente
                                      },
                                      showModal: false,
                                      rBusca: [],
                                      busca: "",
                                    }));
                                  }}
                                >
                                  Selecionar
                                </button>
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </>
              )
            ) : (
              <div className="text-center p-2">
                Nem um resultado encontrado para:{" "}
                <strong>{this.state.busca}</strong>
              </div>
            )}
          </div>
        </StaticDialog>

        <StaticDialog
          isOpen={this.state.newC}
          title="Cadastrar cliente"
          onAfterClose={(result) => {
            this.setState({
              newC: false,
              tpcad: null,
              files: [],
              previews: [],
            });
          }}
        >
          {this.state.tpcad == null ? (
            <div
              style={{ display: "flex", justifyContent: "center", margin: 10 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 100,
                  height: 100,
                  cursor: "pointer",
                  border: "1px solid black",
                }}
                onClick={() => {
                  this.setState({ tpcad: "cpf" });
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <FontAwesomeIcon icon={faUser} />
                  Cadastro de Pessoa Física
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 100,
                  height: 100,
                  cursor: "pointer",
                  marginLeft: 10,
                  border: "1px solid black",
                }}
                onClick={() => {
                  this.setState({ tpcad: "cnpj" });
                }}
              >
                {" "}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <FontAwesomeIcon icon={faStore} />
                  Cadatro de Empresa
                </div>
              </div>
            </div>
          ) : (
            <>
              {this.state.tpcad == "cpf" ? (
                <>
                  <div className="container">
                    <form
                      id="cadastroForm"
                      onSubmit={(e) => {
                        var dados = this.state.dados;
                        e.preventDefault();
                      }}
                    >
                      <div className="mt-3">
                        <div className="mb-2">
                          <label>Tipo de Cliente</label>
                        </div>
                        <select
                          className="form-control"
                          name="type_c"
                          onClick={() => this.handleChange}
                        >
                          <option value="">Selecione</option>
                          <option value="1">Locação</option>
                          <option value="2">Venda</option>
                        </select>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Nome"
                            name="nome"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>

                        <div className="col-md-6">
                          <TextField
                            label="Data de Nascimento"
                            name="data_nascimento"
                            type="text"
                            value={this.state.dados.data_nascimento || ""}
                            onChange={this.handleChange}
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cnpj_cpf"
                            onChange={this.handleChange}
                            mask="999.999.999-99" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Cpf"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="rg"
                            onChange={this.handleChange}
                            mask="99.999.999-9" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Rg"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Nome do Pai"
                            name="npai"
                            value={this.state.npai}
                            onChange={(e) => this.handleChange(e)}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Nome da Mae"
                            name="nmae"
                            value={this.state.nmae}
                            onChange={(e) => this.handleChange(e)}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="telefone"
                            onChange={this.handleChange}
                            mask="" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Telefone"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="celular"
                            onChange={this.handleChange}
                            mask="(99) 9 9999-9999" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="WhatsApp"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>
                      <div>
                        <TextField
                          label="E-mail"
                          name="email"
                          onChange={this.handleChange}
                          variant="outlined" // Pode ser "filled" ou "standard"
                          fullWidth // O campo ocupa toda a largura disponível
                          margin="normal"
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cep"
                            onChange={async (e) => {
                              const cep = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
                              this.setState({ cep });

                              if (cep.length === 8) {
                                fetch(`https://viacep.com.br/ws/${cep}/json/`)
                                  .then((response) => response.json())
                                  .then((data) => {
                                    if (data.error == "true") {
                                      toast.warning("CEP inválido");
                                    } else {
                                      this.setState((prevState) => ({
                                        dados: {
                                          ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                          ["endereco"]: data.logradouro, // Atualiza apenas o campo correspondente
                                          ["bairro"]: data.bairro,
                                          ["cidade"]: data.localidade,
                                          ["estado"]: data.estado,
                                        },
                                      }));
                                    }
                                  })
                                  .catch((error) => {
                                    toast.warning("CEP inválido");
                                  });
                              }
                            }}
                            mask="99.999-999" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CEP:"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Endereço"
                            name="endereco"
                            value={this.state.dados.endereco || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <TextField
                            label="Número"
                            name="numero"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Complemento"
                            name="complemento"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Bairro"
                            name="bairro"
                            onChange={this.handleChange}
                            value={this.state.dados.bairro || ""}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <TextField
                            label="Cidade"
                            name="cidade"
                            value={this.state.dados.cidade || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Estado"
                            name="estado"
                            value={this.state.dados.estado || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="mt-1">
                          <label className="mb-2">Documento:</label>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",

                              flexWrap: "wrap",
                            }}
                          >
                            {this.state.previews.map((item, index) => (
                              <>
                                {item.type === "image" ? (
                                  <>
                                    {" "}
                                    <div
                                      key={index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      <img
                                        src={item.src}
                                        alt={`preview-${index}`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          objectFit: "cover",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          this.handleRemoveImage(index)
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "red",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faClose}
                                          color="#fff"
                                        />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      key={index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        {" "}
                                        <FontAwesomeIcon icon={faFilePdf} />
                                      </div>

                                      <button
                                        onClick={() =>
                                          this.handleRemoveImage(index)
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "red",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faClose}
                                          color="#fff"
                                        />
                                      </button>
                                    </div>
                                  </>
                                )}
                              </>
                            ))}
                          </div>
                          <div
                            className="custom-upl"
                            style={{
                              marginTop:
                                this.state.previews.length > 0 ? "20px" : "0",
                            }}
                          >
                            <input
                              type="file"
                              multiple
                              accept="image/*,application/pdf" // Isso já ajuda a restringir para imagens no navegador
                              onChange={this.handleFileChange}
                            />
                            <button className="btn btn-primary">
                              <FontAwesomeIcon icon={faFileAlt} /> Anexar
                              Documento
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              ) : (
                <>
                  <div className="container">
                    <form
                      id="cadastroForm"
                      onSubmit={(e) => {
                        var dados = this.state.dados;
                        e.preventDefault();
                      }}
                    >
                      <div className="mt-3">
                        <div className="mb-2">
                          <label>Tipo de Cliente</label>
                        </div>
                        <select
                          className="form-control"
                          name="type_c"
                          onClick={() => this.handleChange}
                        >
                          <option value="">Selecione</option>
                          <option value="1">Locação</option>
                          <option value="2">Venda</option>
                        </select>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <TextField
                            label="Nome"
                            name="nome"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Nome fantasia"
                            name="nome_fantasia"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cnpj_cpf"
                            onChange={this.handleChange}
                            mask="99.999.999/9999-99" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Cnpj"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="inscricao_estadual"
                            onChange={this.handleChange}
                            mask="999.999.999.999" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Inscrião Estadual"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="telefone"
                            onChange={this.handleChange}
                            mask="" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="Telefone"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <InputMask
                            name="celular"
                            onChange={this.handleChange}
                            mask="(99) 9 9999-9999" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="WhatsApp"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                      </div>
                      <div>
                        <TextField
                          label="E-mail"
                          name="email"
                          onChange={this.handleChange}
                          variant="outlined" // Pode ser "filled" ou "standard"
                          fullWidth // O campo ocupa toda a largura disponível
                          margin="normal"
                          InputProps={{
                            style: {
                              height: 45,
                              padding: "0 5px",
                            },
                          }}
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <InputMask
                            name="cep"
                            onChange={async (e) => {
                              const cep = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
                              this.setState({ cep });

                              if (cep.length === 8) {
                                fetch(`https://viacep.com.br/ws/${cep}/json/`)
                                  .then((response) => response.json())
                                  .then((data) => {
                                    if (data.error == "true") {
                                      toast.warning("CEP inválido");
                                    } else {
                                      this.setState((prevState) => ({
                                        dados: {
                                          ...prevState.dados, // Mantém os outros campos do objeto `dados`
                                          ["endereco"]: data.logradouro, // Atualiza apenas o campo correspondente
                                          ["bairro"]: data.bairro,
                                          ["cidade"]: data.localidade,
                                          ["uf"]: data.uf,
                                        },
                                      }));
                                    }
                                  })
                                  .catch((error) => {
                                    toast.warning("CEP inválido");
                                  });
                              }
                            }}
                            mask="99.999-999" // Máscara de telefone
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                label="CEP:"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    height: 45,
                                    padding: "0 5px",
                                  },
                                }}
                                margin="normal"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Endereço"
                            name="endereco"
                            value={this.state.dados.endereco || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <TextField
                            label="Número"
                            name="numero"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Complemento"
                            name="complemento"
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-4">
                          <TextField
                            label="Bairro"
                            name="bairro"
                            onChange={this.handleChange}
                            value={this.state.dados.bairro || ""}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <TextField
                            label="Cidade"
                            name="cidade"
                            value={this.state.dados.cidade || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextField
                            label="Estado"
                            name="estado"
                            value={this.state.dados.estado || ""}
                            onChange={this.handleChange}
                            variant="outlined" // Pode ser "filled" ou "standard"
                            fullWidth // O campo ocupa toda a largura disponível
                            margin="normal"
                            InputProps={{
                              style: {
                                height: 45,
                                padding: "0 5px",
                              },
                            }}
                          />
                        </div>
                        <div className="mt-1">
                          <div className="mb-2">
                            <label>Documento</label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",

                              flexWrap: "wrap",
                            }}
                          >
                            {this.state.previews.map((item, index) => (
                              <>
                                {item.type === "image" ? (
                                  <>
                                    {" "}
                                    <div
                                      key={index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      <img
                                        src={item.src}
                                        alt={`preview-${index}`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          objectFit: "cover",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          this.handleRemoveImage(index)
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "red",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faClose}
                                          color="#fff"
                                        />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      key={index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #ccc",
                                          borderRadius: "5px",
                                        }}
                                      >
                                        {" "}
                                        <FontAwesomeIcon icon={faFilePdf} />
                                      </div>

                                      <button
                                        onClick={() =>
                                          this.handleRemoveImage(index)
                                        }
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "red",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faClose}
                                          color="#fff"
                                        />
                                      </button>
                                    </div>
                                  </>
                                )}
                              </>
                            ))}
                          </div>
                          <div
                            className="custom-upl"
                            style={{
                              marginTop:
                                this.state.previews.length > 0 ? "20px" : "0",
                            }}
                          >
                            <input
                              type="file"
                              multiple
                              accept="image/*,application/pdf" // Isso já ajuda a restringir para imagens no navegador
                              onChange={this.handleFileChange}
                            />
                            <button className="btn btn-primary">
                              <FontAwesomeIcon icon={faFileAlt} /> Anexar
                              Documento
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              )}
            </>
          )}
          {this.state.tpcad != null && (
            <>
              <div className="modal-fotter">
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    var dados = this.state.dados;

                    if (this.state.tpcad == "cpf") {
                      if (dados.data_nascimento == undefined) {
                        toast.warn("Selecione uma data de nascimento");
                        return;
                      }
                    }

                    const formData = new FormData();

                    // Adiciona os dados do formulário ao FormData
                    formData.append("nome", dados.nome);
                    if (this.state.tpcad == "cpf") {
                      formData.append(
                        "data_nascimento",
                        this.state.dados.data_nascimento
                      );
                      formData.append("rg", this.state.dados.rg);
                      formData.append("npai", this.state.dados.npai);
                      formData.append("nmae", this.state.dados.nmae);
                      formData.append(
                        "complemento",
                        this.state.dados.complemento
                      );
                    } else {
                      formData.append(
                        "nome_fantasia",
                        this.state.dados.nome_fantasia
                      );
                      formData.append(
                        "inscricao_estadual",
                        this.state.dados.inscricao_estadual
                      );
                    }
                    formData.append("cnpj_cpf", dados.cnpj_cpf);
                    formData.append("email", dados.email);
                    formData.append("telefone", dados.telefone);
                    formData.append("celular", dados.celular);
                    formData.append("cep", dados.cep);
                    formData.append("endereco", dados.endereco);
                    formData.append("numero", dados.numero);
                    formData.append("bairro", dados.bairro);
                    formData.append("cidade", dados.cidade);
                    formData.append("estado", dados.estado);

                    // Verifique se há uma imagem e adicione ao FormData

                    this.state.files.forEach((file) => {
                      formData.append("images", file);
                    });

                    fetch(
                      `${apiUrl}/cadastrar-cliente${this.state.files.length > 0 ? "/files" : ""
                      }`,
                      {
                        method: "POST",

                        body: formData,
                      }
                    )
                      .then((response) => {
                        if (response.status == 200) {
                          response.json().then((data) => {
                            return;
                            this.setState((prevState) => ({
                              dados: {
                                ...prevState.dados, // Mantém os dados existentes
                                cliente: {
                                  id: data.id,
                                  nome: dados.nome,
                                  cnpj_cpf: dados.cnpj_cpf,
                                }, // Adiciona a nova propriedade cliente
                              },
                              newC: false,
                              tpcad: null,
                            }));
                            toast.success("Cliente adicionado");
                          });
                        }
                      })
                      .catch((err) => {
                        toast.error("Falha na comunicação com o servidor!");
                      });
                  }}
                >
                  <FontAwesomeIcon icon={faSave} /> Salvar
                </button>
              </div>
            </>
          )}
        </StaticDialog>
      </div >
    );
  }
}

export default Lease;
